import { render, staticRenderFns } from "./MarketOpeningHoursList.vue?vue&type=template&id=0fe09cee"
import script from "./MarketOpeningHoursList.vue?vue&type=script&lang=js"
export * from "./MarketOpeningHoursList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports